<template>
    <div class="wrapper">
        <div class="box">
            <div class="header">
                <i class="material-icons">android</i>
                Android
            </div>
            <div class="content">
                {{this.androidCount}}
                <span>Devices</span>
            </div>
        </div>
        <div class="box">
            <div class="header">
                <i class="material-icons">desktop_mac</i>
                iOS
            </div>
            <div class="content">
                {{this.iosCount}}
                <span>Devices</span>
            </div>
        </div>
        <div class="box">
            <div class="header">
                <i class="material-icons">desktop_windows</i>
                Web
            </div>
            <div class="content">
                {{this.webCount}}
                <span>Devices</span>
            </div>
        </div>
        <div class="box">
            <div class="header">
                <i class="material-icons">help_outline</i>
                Unknown
            </div>
            <div class="content">
                {{this.unknownCount}}
                <span>Devices</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'devices',
    props: ['data'],
    data() {
        return {
            androidCount: 0,
            iosCount: 0,
            webCount: 0,
            unknownCount: 0
        };
    },
    mounted() {
        this.renderData(this.data);
    },
    watch: {
        data: function(newVal, oldVal) {
            this.renderData(this.data);
        }
    },
    methods: {
        renderData: function(data) {
            if (!data || !data[0])
                return;

            this.androidCount = data[0].android ? data[0].android : 0;
            this.iosCount = data[0].ios ? data[0].ios : 0;
            this.webCount = data[0].web ? data[0].web : 0;
            this.unknownCount = data[0].unknown ? data[0].unknown : 0;
        }
    }
};
</script>

<style lang="scss" scoped>
    .wrapper {
        width: 45em;
        padding: 2em;
    }

    .box {
        width: 11em;
        height: 100%;
        float: none;
        display: inline-block;
        border: 1px solid #eaecf1;
        border-radius: 4px;
        text-align: center;
        margin: 0 .5em;

        .header {
            text-align: center;
            font-size: 12px;
            color: #454D5A;
            font-weight: 400;
            padding: 1em;
            border-bottom: 1px solid #eaecf1;

            i {
                vertical-align: middle;
                margin: 0 5px 0 0;
            }
        }

        .content {
            padding: 2em 0;
            font-size: 2em;
            color: #52D160;
            line-height: 28px;
            font-weight: 400;

            span {
                display: block;
                font-size: 10px;
                color: #454D5A;
                font-weight: 400;
            }
        }
    }
</style>